export default {
    data() {
        return {};
    },
    mounted() {
    },
    methods: {
        checkGeneralEnvironment: function () {
            return 4;
        },
        checkGeneralEnvironmentDongDu: function () {
            return true;
        },
    },
    computed:{}
};


// WEBPACK FOOTER //
// ./src/util/general_environment.js